import { selectAllTerminal, insertTerminal, updateTerminal, deleteTerminal, batchTransferTerminal, uploadTerminalModel, syncTerminalOrg, refreshTerminal,abandonedTerminal } from "../../api/config/modules/TerminalFile";

const state = {
    selectAllTerminal: {},
    insertTerminal: {},
    updateTerminal: {},
    deleteTerminal: {},
    batchTransferTerminal: {},
    uploadTerminalModel: {},
    syncTerminalOrg: {},
    refreshTerminal: {},
    abandonedTerminal: {}
};

const mutations = {
    SET_SELECTALLTERMINAL: (state, selectAllTerminal) => {
        state.selectAllTerminal = selectAllTerminal;
    },
    SET_INSERTTERMINAL: (state, insertTerminal) => {
        state.insertTerminal = insertTerminal;
    },
    SET_UPDATETERMINAL: (state, updateTerminal) => {
        state.updateTerminal = updateTerminal;
    },
    SET_DELETETERMINAL: (state, deleteTerminal) => {
        state.deleteTerminal = deleteTerminal;
    },
    SET_BATCHTERMINAL: (state, batchTransferTerminal) => {
        state.batchTransferTerminal = batchTransferTerminal;
    },
    SET_UPLOADTERMINAL: (state, uploadTerminalModel) => {
        state.uploadTerminalModel = uploadTerminalModel;
    },
    SET_SYNCTERMINALORG: (state, syncTerminalOrg) => {
        state.syncTerminalOrg = syncTerminalOrg;
    },
    SET_REFRESHTERMINAL: (state, refreshTerminal) => {
        state.refreshTerminal = refreshTerminal;
    },
    SET_ABANDONEDTERMINAL: (state, abandonedTerminal) => {
        state.abandonedTerminal = abandonedTerminal;
    },
};

const actions = {
    GET_SELECTALLTERMINAL: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            selectAllTerminal(data)
                .then((res) => {
                    commit("SET_SELECTALLTERMINAL", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_INSERTTERMINAL: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            insertTerminal(data)
                .then((res) => {
                    commit("SET_INSERTTERMINAL", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_UPDATETERMINAL: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            updateTerminal(data)
                .then((res) => {
                    commit("SET_UPDATETERMINAL", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_DELETETERMINAL: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            deleteTerminal(data)
                .then((res) => {
                    commit("SET_DELETETERMINAL", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_BATCHTERMINAL: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            batchTransferTerminal(data)
                .then((res) => {
                    commit("SET_BATCHTERMINAL", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_UPLOADTERMINAL: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            uploadTerminalModel(data)
                .then((res) => {
                    commit("SET_UPLOADTERMINAL", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_SYNCTERMINALORG: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            syncTerminalOrg(data)
                .then((res) => {
                    commit("SET_SYNCTERMINALORG", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_REFRESHTERMINAL: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            refreshTerminal(data)
                .then((res) => {
                    commit("SET_REFRESHTERMINAL", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_ABANDONEDTERMINAL: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            abandonedTerminal(data)
                .then((res) => {
                    commit("SET_ABANDONEDTERMINAL", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
